<template>
  <div>
    <div class="app-header header-shadow">
      <div class="app-header__logo">
        <div class="logo-src"></div>
        <div class="header__pane ml-auto">
          <div>
            <button
              type="button"
              class="hamburger close-sidebar-btn hamburger--elastic"
              data-class="closed-sidebar"
            >
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="app-header__mobile-menu">
        <div>
          <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
      <div class="app-header__menu">
        <span>
          <button
            type="button"
            class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
          >
            <span class="btn-icon-wrapper">
              <i class="fa fa-ellipsis-v fa-w-6"></i>
            </span>
          </button>
        </span>
      </div>
      <div class="app-header__content">
        <div class="app-header-right">
          <div class="header-dots" v-if="$store.state.institucion">
            <div class="dropdown">
              <button
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                data-toggle="dropdown"
                class="p-0 mr-2 btn btn-link"
              >
                <span class="icon-wrapper icon-wrapper-alt rounded-circle">
                  <span class="icon-wrapper-bg bg-primary"></span>
                  <i class="text-alternate fas fa-school"></i>
                </span>
              </button>
              <div
                tabindex="-1"
                role="menu"
                aria-hidden="true"
                class="dropdown-menu-xl rm-pointers dropdown-menu dropdown-menu-right"
              >
                <div class="dropdown-menu-header">
                  <div class="dropdown-menu-header-inner bg-plum-plate">
                    <div
                      class="menu-header-image"
                      style="background-image: url('../assets/images/dropdown-header/abstract4.jpg');"
                    ></div>
                    <div class="menu-header-content text-white">
                      <h5 class="menu-header-title">Datos de Mi institucion</h5>
                      <h6 class="menu-header-subtitle" v-if="$store.state.institucion">{{$store.state.institucion.razon_social}}</h6>
                    </div>
                  </div>
                </div>
                <div class="grid-menu grid-menu-xl grid-menu-3col">
                  <div class="no-gutters row">
                    <div class="col-sm-6 col-xl-4">
                      <router-link
                                :class="'btn-icon-vertical btn-square btn-transition btn btn-outline-link'"
                                :to="{name:'ListarInstituciones'}"
                                v-if="institucionSelected"
                              ><i
                          class="fa fa-undo-alt icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3"
                        ></i>Cambiar</router-link>
                    </div>
                    <div class="col-sm-6 col-xl-4">
                      <router-link
                                :class="'btn-icon-vertical btn-square btn-transition btn btn-outline-link'"
                                :to="{name:'EditarInstitucion', params:{id:$store.state.institucion.id}}"
                                v-if="institucionSelected"
                              ><i
                          class="fa fa-edit icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3"
                        ></i>Editar</router-link>
                    </div>
                    <div class="col-sm-6 col-xl-4">
                      <button @click="bajarInsitucion($store.state.institucion)"
                        class="btn-icon-vertical btn-square btn-transition btn btn-outline-link"
                      >
                        <i
                          class="fa fa-trash icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3"
                        ></i>
                        Dar de baja
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="header-dots" v-if="$store.state.credentials.usuario == $store.state.credentials.password">
            <div class="dropdown">
              <button
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                data-toggle="dropdown"
                class="p-0 mr-2 btn btn-link"
              >
                <span class="icon-wrapper icon-wrapper-alt rounded-circle">
                  <span class="icon-wrapper-bg bg-danger"></span>
                  <i class="icon text-danger icon-anim-pulse ion-android-notifications"></i>
                </span>
              </button>
              <div
                tabindex="-1"
                role="menu"
                aria-hidden="true"
                class="dropdown-menu-xl rm-pointers dropdown-menu dropdown-menu-right"
              >
                <div class="dropdown-menu-header">
                  <div class="dropdown-menu-header-inner bg-plum-plate">
                    <div
                      class="menu-header-image"
                      style="background-image: url('../assets/images/dropdown-header/abstract4.jpg');"
                    ></div>
                    <div class="menu-header-content text-white">
                      <h5 class="menu-header-title">Mensajes</h5>
                    </div>
                  </div>
                </div>
                <div class="grid-menu grid-menu-xl grid-menu-3col">
                  <div class="no-gutters row">
                    <div class="col-sm-12 col-xl-12">
                      <router-link
                                :class="'btn-icon-vertical btn-square btn-transition btn btn-outline-link'"
                                :to="{name:'EditarPerfil'}"
                              ><i
                          class="fa fa-key icon-gradient bg-night-fade btn-icon-wrapper btn-icon-lg mb-3"
                        ></i>Le recomendamos cambiar la contraseña por defecto</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="header-btn-lg pr-0">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="btn-group">
                    <a
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="p-0 btn"
                    >
                      <div class="widget-content-left header-user-info">
                        <div class="widget-heading">
                          <i class="fa fa-angle-down mr-2 opacity-8"></i>
                          {{user.name}}
                        </div>
                        <div
                          class="widget-subheading"
                          v-if="$store.state.institucion"
                        >{{$store.state.institucion.razon_social}}</div>
                      </div>
                    </a>
                    <div
                      tabindex="-1"
                      role="menu"
                      aria-hidden="true"
                      class="rm-pointers dropdown-menu-lg dropdown-menu dropdown-menu-right"
                    >
                      <div class="dropdown-menu-header">
                        <div class="dropdown-menu-header-inner bg-info">
                          <div
                            class="menu-header-image opacity-2"
                            style="background-image: url('../assets/images/dropdown-header/city3.jpg');"
                          ></div>
                          <div class="menu-header-content text-left">
                            <div class="widget-content p-0">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                  <div class="widget-heading">{{user.name}}</div>
                                  <div
                                    class="widget-subheading opacity-8"
                                    v-if="$store.state.institucion"
                                  >{{$store.state.institucion.razon_social}}</div>
                                </div>
                                <div class="widget-content-right mr-2">
                                  <button
                                    @click="logout"
                                    class="btn-pill btn-shadow btn-shine btn btn-focus"
                                  >Salir</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="scroll-area-xs" style="height: 150px;">
                        <div class="scrollbar-container ps">
                          <ul class="nav flex-column">
                            <li class="nav-item-header nav-item">Opciones</li>
                            <li class="nav-item">
                              <router-link
                                :class="'nav-link'"
                                :to="{name:'EditarPerfil'}"                                
                              >Cambiar Contraseña</router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from "vuex";
import "bootstrap";
import "metismenu";
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";
import "@/assets/js/demo";

export default {
  name: "Menu",

  data() {
    return {
      institucionSelected: false,
      institucionId:null
    };
  },
  computed: {
    ...Vuex.mapState(["user", "institucion"]),
  },
  watch: {
    institucion: function (institucion) {
      if (institucion) {
        this.institucionSelected = true;
      } else {
        this.institucionSelected = false;
      }
    },
  },
  methods: {
    ...Vuex.mapActions({
      logoutAction: "logout",
    }),
    logout() {
      this.logoutAction().then(() => {
        this.$router.push({
          name: "Login",
        });
      });
    },
    bajarInsitucion(institucion) {
        Swal.fire({
            title: "¿Estás seguro?",
            text: `¿Deseas dar de baja ${institucion.razon_social} de manera permanente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Baja",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
            this.loading = true;
            axios
                .delete("institucion/" + institucion.id)
                .then(res => {
                Swal.fire(
                    "Baja",
                    `${res.data.institucion.razon_social} se ha dado de baja con éxito.`,
                    "success"
                );
                this.$store.dispatch("setInstitucion", null);
                localStorage.removeItem("institucion")
                this.$router.push({name:'ListarInstituciones'}); 
                console.log(this.$refs);
                this.$refs.datatable.update();
                })
                .catch(err => console.log(err))
                .finally(() => (this.loading = false));
            }
        });
        }
  },
  created() {
    // console.log(user);
  },
  mounted() {
    require ('@/assets/js/eventosdemenu');
    $(".vertical-nav-menu").metisMenu();
    if (this.institucion) {
      this.institucionSelected = true;
    } else {
      this.institucionSelected = false;
    }

  },
};
</script>
